import { FrameBody,Error,ErrorProps } from "@npd-ng/adp-benchmark";
import errorIcon from '../assets/error_icon.svg';
import { Content } from "../types/Content";
import { useStateContext } from "../hooks/useStateContext";
import { useDedupEffect } from "../util/useDedupEffect";
import { useDeviceValidationService } from "../hooks/useDeviceValidationService";
const logPrefix = "[ADPClient][ErrorView]"
export default function HardwareCheckFailureView() {
  const { dispatch,state} = useStateContext();
  const {postDeviceValidationLog} = useDeviceValidationService( dispatch,state)
  console.warn(logPrefix, "HardwareCheckFailureView", state.deviceReadinessState.validationError);
  const content= state.staticContent as Content;
  const type = state.deviceReadinessState.validationError || "FailedHardwareCheck";
  const deviceReadiness =content.deviceReadiness[type];
  const actions = content.actions
  const errorProps: ErrorProps = {
    error:{
      iconSrc: errorIcon,
      title: deviceReadiness.title,
      message: deviceReadiness.message,
      buttons:[{
          label: actions.exit,
          action:()=>{window.close()},
          variant: "secondary"
      }]}
    }
    useDedupEffect(()=>{
          if(state.deviceReadinessSummary?.responses){
            postDeviceValidationLog(state.deviceReadinessSummary?.responses);
        }
     },[state.deviceReadinessSummary?.responses])   
  return (
    <>
       <FrameBody>
          <Error {...errorProps}/>
       </FrameBody>

    </>
  )
}
